import { Instance, SnapshotOut, types, flow, getRoot } from "mobx-state-tree"
import { RootStoreModel } from ".."

/**
 * 銀行列表 store
 */
export const BankStoreModel = types
  .model("BankStore")
  .props({
    bankList: types.map(types.string),
  })
  .views(() => ({}))
  .actions((self) => {
    const { apiStore } = getRoot<Instance<typeof RootStoreModel>>(self)
    const setBankList = (deta) => {
      self.bankList.clear()
      const entries =
        deta instanceof Map
          ? Array.from(deta.entries())
          : Object.entries(deta || {})
      entries.forEach(([k, v]) => {
        self.bankList.set(String(k), String(v))
      })
    }

    const getBankList = flow(function* () {
      const res = yield apiStore.getBankList()
      if (res?.bank) {
        setBankList(res.bank)
      } else if (res?.data?.bank) {
        setBankList(res.data.bank)
      }
    })

    return {
      getBankList,
      setBankList,
    }
  })

type BankStoreType = Instance<typeof BankStoreModel>
export interface BankStore extends BankStoreType {}
type BankStoreSnapshotType = SnapshotOut<typeof BankStoreModel>
export interface BankStoreSnapshot extends BankStoreSnapshotType {}
export const createBankStoreDefaultModel = () => types.optional(BankStoreModel, {})
